import {Grid, Typography} from '@yandex-delivery/blocks'

import {Body, CitySuggest, PointSelect} from 'src/shared/components/desktop'
import {i18n} from 'src/shared/config'
import {DestinationPointDeliveryMethod} from 'src/shared/types'

import {PointsByCityModal} from '../PointsByCityModal/PointsByCityModal'
import {usePointPickUp} from './hooks'
import type {Props} from './types'

// todo есть ощущение, что это один и тот же компонент с PointDropOff
export function PointPickUp(props: Props) {
  const {
    citySelectHandler,
    closeModalHandler,
    isPending,
    isModalVisible,
    openModalHandler,
    points,
    pointSelectHandler,
    preparedPoints,
    selectedCity,
    selectedPoint,
    names,
  } = usePointPickUp({name: props.name})

  return (
    <>
      <Grid xs={12} item>
        <Body
          lead={
            <Typography group="tight" mt="m" thickness="medium" variant="body2">
              {i18n('ndd.point.point-selector.city', 'Город')}
            </Typography>
          }
          tail={<CitySuggest data-testid={`ndd.city_${names.city}`} name={names.city} pointType="b" />}
        />
      </Grid>
      <Grid xs={12} item>
        <Body
          lead={
            <Typography group="tight" mt="m" thickness="medium" variant="body2">
              {i18n('ndd.point.point-selector.pickup_point', 'Пункт выдачи')}
            </Typography>
          }
          tail={
            <PointSelect
              data-testid={`ndd.point_${names.point}`}
              isDisabled={!selectedCity}
              isPending={isPending}
              name={names.point}
              onShow={openModalHandler}
              placeholder={i18n('ndd.point.point-selector.select_pickup_point', 'Выберите пункт выдачи')}
              points={points}
              trailButtonCaption={i18n('ndd.delivery-method.field.pickup-point.reception-point.button', 'Все пункты')}
            />
          }
        />
      </Grid>
      <PointsByCityModal
        isOpen={isModalVisible}
        isPending={isPending}
        onCitySelect={citySelectHandler}
        onClose={closeModalHandler}
        onPointSelect={pointSelectHandler}
        points={preparedPoints}
        pointType={DestinationPointDeliveryMethod.PickUpPoint}
        selectedPoint={selectedPoint}
        selectedPointCity={selectedCity?.address}
      />
    </>
  )
}
